import React from 'react';
import './full.module.scss';
import { Page, Pane } from '../../components/atoms/applications/page';
import { MultiCreatorLink } from '../../components/molecules/multi_creator/MultiCreatorBanner';
import TroubleShechan from './images/trouble_shechan.png';
import { SpBr } from '../../../commonv3/components/atoms/layouts/br';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';

export const MultiCreatorFullPage = () => {
  useNavigation(NavigationSpecs.standard());

  return (
    <div styleName="background">
      <Page styleName="full_page">
        <Pane styleName="pane">
          <div styleName="header">
            受講人数が満員のため
            <br />
            入会申込を一時停止しております
          </div>
          <div styleName="message">
            MULTI CREATOR COURSE Designerは、
            <br />
            入会殺到につき、現在入会申し込みを
            <SpBr />
            一時停止しております。
            <br />
            お待ちいただく間、下記フォームにご登録いただくと
            <br />
            申し込み再開時にメールにてご連絡差し上げます。
          </div>
          <div styleName="button-wrapper">
            <MultiCreatorLink
              text="入会希望フォームに進む"
              href="https://docs.google.com/forms/d/e/1FAIpQLSdszpgF1F8bu2jMCIk0ExMgwn-wOPNqfqqS-OQQratOXgOGLw/viewform"
            />
          </div>
        </Pane>
      </Page>
      <img styleName="trouble-she-chan" src={TroubleShechan} />
    </div>
  );
};
